import { jsonApiRequest } from "../api";

// ==================== SCHEMA GRANTS ====================

export async function getSchemaGrants(direction = "outbound") {
  return await jsonApiRequest("GET", `schema-grants?direction=${direction}`);
}

export async function createSchemaGrant(data) {
  return await jsonApiRequest("POST", `schema-grants`, data);
}

export async function revokeSchemaGrant(id) {
  return await jsonApiRequest("DELETE", `schema-grants/${id}`);
}

// ==================== SCHEMA INVITATIONS ====================

export async function getSchemaInvitations() {
  return await jsonApiRequest("GET", `schema-invitations`);
}

export async function createSchemaInvitation(data) {
  return await jsonApiRequest("POST", `schema-invitations`, data);
}

export async function revokeSchemaInvitation(id) {
  return await jsonApiRequest("DELETE", `schema-invitations/${id}`);
}

export async function acceptSchemaInvitation(token) {
  return await jsonApiRequest("POST", `schema-invitations/accept`, { token });
}

/**
 * Gets invitation details by token (anonymous endpoint, for acceptance page).
 */
export async function getInvitationByToken(token) {
  return await jsonApiRequest("GET", `schema-invitations/by-token/${token}`);
}

// ==================== SHARED SCHEMAS ====================

export async function getSharedSchemas() {
  return await jsonApiRequest("GET", `pim/schemas/shared`);
}

// ==================== SUBMISSIONS ====================

export async function getOutboundSubmissions() {
  return await jsonApiRequest("GET", `submissions/outbound`);
}

export async function getInboundSubmissions() {
  return await jsonApiRequest("GET", `submissions/inbound`);
}

export async function getSubmission(id) {
  return await jsonApiRequest("GET", `submissions/${id}`);
}

export async function getSubmissionItems(id, page = 1, pageSize = 50) {
  return await jsonApiRequest("GET", `submissions/${id}/items?page=${page}&pageSize=${pageSize}`);
}

export async function createSubmission(data) {
  return await jsonApiRequest("POST", `submissions`, data);
}

export async function addSubmissionItems(id, items) {
  return await jsonApiRequest("POST", `submissions/${id}/items`, items);
}

export async function submitSubmission(id) {
  return await jsonApiRequest("POST", `submissions/${id}/submit`);
}

export async function acceptSubmission(id, data) {
  return await jsonApiRequest("POST", `submissions/${id}/accept`, data);
}

export async function rejectSubmission(id, data) {
  return await jsonApiRequest("POST", `submissions/${id}/reject`, data);
}
